import { Button, Text } from "@tblabs/truffle";
import { BasketIcon } from "./BasketIcon";
import { Basket } from "../../../Services/Basket/Basket";


export class BasketOpenerButton extends Button
{
    constructor(_basket: Basket)
    {
        super("");
        this.Class("navbar__cart");
        this.Attribute("aria-label", "Pokaż koszyk");
        this.Attribute("data-testid", "basket-button");

        // _basket.Items.OnChange(() => {
        //     console.log("Basket items changed", _basket.Items.CountRef.value);
        // },true);
        // console.log("BasketButton constructor", _basket.Items.CountRef.value);

        this.Append(
            new BasketIcon(),
            new Text(_basket.Items.CountRef).Class("navbar__cart-badge").TestAttr("basket-count")
                .VisibleWhen(_basket.Items.CountRef, v => v > 0)
        );
    }
}
